<template>
    <el-button type="primary" plain  icon="el-icon-plus" v-on:click="clickEvent()">新增</el-button>
</template>
  
  <script>
  
  export default {
    name: 'add-button',
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// AddButton.vue?61f140c5